import { call, put, takeEvery } from "redux-saga/effects"

// Crypto Redux States
import {GET_BLOGSUBCAT, DELETE_BLOGSUBCAT,UPDATE_BLOGSUBCAT,ADD_BLOGSUBCAT, GET_BLOGCAT, 
  DELETE_BLOGCAT,UPDATE_BLOGCAT,ADD_BLOGCAT,
   GET_FEEDBACK, DELETE_FEEDBACK,UPDATE_FEEDBACK,ADD_FEEDBACK,
   GET_CAMPAIN, DELETE_CAMPAIN,UPDATE_CAMPAIN,ADD_CAMPAIN,
   GET_CAMPAIN_HISTORY, DELETE_CAMPAIN_HISTORY,UPDATE_CAMPAIN_HISTORY,ADD_CAMPAIN_HISTORY,
   GET_CAMPAINPERIOD, DELETE_CAMPAINPERIOD,UPDATE_CAMPAINPERIOD,ADD_CAMPAINPERIOD,
   GET_CAMPAINCATEGORY, DELETE_CAMPAINCATEGORY,UPDATE_CAMPAINCATEGORY,ADD_CAMPAINCATEGORY,
   GET_COMPANY, DELETE_COMPANY,UPDATE_COMPANY,ADD_COMPANY,
   GET_SECTOR, DELETE_SECTOR,UPDATE_SECTOR,ADD_SECTOR,
   GET_SUBSECTOR, DELETE_SUBSECTOR,UPDATE_SUBSECTOR,ADD_SUBSECTOR,
   GET_JOB, DELETE_JOB,UPDATE_JOB,ADD_JOB,
  GET_ADVERT, DELETE_ADVERT,UPDATE_ADVERT,ADD_ADVERT, GET_AVAILABLE, DELETE_AVAILABLE,UPDATE_AVAILABLE,ADD_AVAILABLE,GET_OFFER, DELETE_OFFER,UPDATE_OFFER,ADD_OFFER, GET_BLOGS, GET_RESERVATION, DELETE_RESERVATION,UPDATE_RESERVATION,ADD_RESERVATION,GET_SLİDERS,GET_SSS,DELETE_SSS,ADD_SSS,UPDATE_SSS, DELETE_DYNAMICFORM, DELETE_PRODUCTCATEGORY, DELETE_DYNAMICFORMEXTRA, DELETE_COURSESCHEDULES,
  DELETE_GALLERY, DELETE_NEWS, GET_DYNAMICFORM_EXTRA_EXTRA, GET_DYNAMICFORM_EXTRA, UPDATE_DYNAMICFORM, GET_CLASSES, GET_CLASSATTENDANCE,
  UPDATE_LESSONS_TIME, UPDATE_CONTACT, UPDATE_ABOUT, GET_TEACHER_WORKSHOP, GET_SUBPROJECT, UPDATE_REFERANCES, ADD_REFERANCES, GET_REFERANCES, ADD_WORKSHOP2, ADD_APPSETTING,
  ADD_WORKSHOPSUBDOMAIN, UPDATE_GALLERY, GET_GALLERY, UPDATE_WORKSHOP2, UPDATE_MEGA, UPDATE_AUTH, GET_AUTHORITY, GET_CONTACT,GET_ABOUT,
  UPDATE_WORKSHOPSESSION, UPDATE_SUBDOMAIN, ADD_COURSE, ADD_MEGA, GET_MEGA, GET_NEWS, GET_PROJECTSNEW, GET_SLIDER, GET_DYNAMICFORM, GET_EVENT,
  GET_TeacherMega, GET_WorkshopSessionMega, GET_CourseSchedulesMega, GET_POPUP, GET_USERS, GET_USER_PROFILE,
  ADD_NEW_USER, ADD_USER,DELETE_USER, UPDATE_USER, GET_WORKSHOP, ADD_POPUP, ADD_PRODUCTCATEGORY, ADD_SLIDER,
  ADD_PROJECT, ADD_NEWS, UPDATE_NEWS, UPDATE_TEACHER, UPDATE_COURSESCHEDULES, UPDATE_SLIDER, UPDATE_PROJECT, GET_WORKSHOP2,
  ADD_LESSONS_TIME, ADD_DYNAMIC_FORM, DELETE_MEGA, DELETE_SLIDER,DELETE_BLOG, DELETE_POPUP, DELETE_REFERANCES, ADD_GALLERY,
  ADD_GALLERYMULTIPLE, DELETE_DYNAMICFORMEXTRAEXTRA, GET_EDUCATION, GET_SUBEDUCATION, UPDATE_EDUCATION, ADD_EDUCATION,
  UPDATE_SUBEDUCATION, ADD_SUBEDUCATION, DELETE_SUBEDUCATION, GET_PRODUCTCATEGORY, GET_PRODUCT, ADD_BLOG, UPDATE_PRODUCTCATEGORY,UPDATE_BLOG,ADD_PRODUCT,UPDATE_PRODUCT,DELETE_PRODUCT, GET_CAMPAINCOMPANY_HISTORY, UPDATE_CAMPAINCOMPANY_HISTORY, DELETE_CAMPAINCOMPANY_HISTORY, ADD_CAMPAINCOMPANY_HISTORY, DELETE_AUTH,
  GET_FEEDBACKCATEGORY,
  UPDATE_FEEDBACKCATEGORY,
  ADD_FEEDBACKCATEGORY,
  DELETE_FEEDBACKCATEGORY,
  ADD_WEBAPP,
  UPDATE_WEBAPP,
  GET_WEBAPP,
  DELETE_WEBAPP,
  GET_SUBS
} from "./actionTypes"

import {

  
  addCampainCategorySuccess,
  updateCampainCategorySuccess,
  getCampainCategorySuccess,
  deleteCampainCategorySuccess,

  addCampainPeriodSuccess,
  updateCampainPeriodSuccess,
  getCampainPeriodSuccess,
  deleteCampainPeriodSuccess,
  
  addCampainHistorySuccess,
  updateCampainHistorySuccess,
  getCampainHistorySuccess,
  deleteCampainHistorySuccess,


  addCampainSuccess,
  updateCampainSuccess,
  getCampainSuccess,
  deleteCampainSuccess,

  addJobSuccess,
  updateJobSuccess,
  getJobSuccess,
  deleteJobSuccess,

  addSectorSuccess,
  updateSectorSuccess,
  getSectorSuccess,
  deleteSectorSuccess,


  addSubSectorSuccess,
  updateSubSectorSuccess,
  getSubSectorSuccess,
  deleteSubSectorSuccess,

  addCompanySuccess,
  updateCompanySuccess,
  getCompanySuccess,
  deleteCompanySuccess,


  addBlogSubCatSuccess,
  updateBlogSubCatSuccess,
  getBlogSubCatSuccess,
  deleteBlogSubCatSuccess,


  addFeedBackSuccess,
  updateFeedBackSuccess,
  getFeedBackSuccess,
  deleteFeedBackSuccess,

  addBlogCatSuccess,
  updateBlogCatSuccess,
  getBlogCatSuccess,
  deleteBlogCatSuccess,
  addOfferSuccess,
  updateOfferSuccess,
  getOfferSuccess,
  deleteOfferSuccess,
  getUsersFail,
  getUserProfileSuccess,
  getUserProfileFail,
  addUserFail,
  addUserSuccess1,
  addUserSuccess,
  addSliderSuccess,
  addAdvertSuccess,
  updateAdvertSuccess,
  getAdvertSuccess,
  deleteAdvertSuccess,
  addSSSSuccess,
  updateSSSSuccess,
  getSSSSuccess,
  deleteSSSSuccess,
  updateUserSuccess,
  updateUserFail,
  deleteUserSuccess,
  deleteUserFail,
  getPopupSuccess,
  getWorkshopSuccess,
  getWorkshopSessionSuccess,
  getApplicationSuccess,
  getSliderSuccess,
  getProjectSuccess,
  getNewsSuccess,
  getMegaSuccess,
  getAboutSuccess,
  getTeacherSuccess,
  getDynamicSuccess,
  getAuthSuccess,
  getAuthUpdateSuccess,
  updateSubdomainSuccess,
  updateSuccessCourseSchedules,
  updateWorkShopSessionSuccess,
  updateTeacherSuccess,
  updateSliderSuccess,
  updateSuccessProject,
  updateContactSuccess,
  updateAboutSuccess,
  updateNewsSuccess,
  updateBlogSuccess,
  updateMegaSuccess,
  getWorkshop2Success,
  updateWorkShop2Success,
  getGallerySuccess,
  updateGallerySuccess,
  getReferancesSuccess,

  addSuccessReferances,
  updateSuccessReferances,
  getSubProjectSuccess,
  getTeacherWorkshopSuccess,
  addSuccessLessonsTime,
  updateLessonsTimeSuccess,
  getClassAttendanceSuccess,
  getClassesSuccess,
  updateDynamicFormSuccess,
  addDynamicFormSuccess,
  getDynamicFormExtraSuccess,
  getDynamicFormExtraExtraSuccess,

  addMegaSuccess,
  deleteMegaSuccess,
  deleteProductCategorySuccess,
  deleteNewsSuccess,
  deleteSliderSuccess,
  deleteBlogSuccess,
  deletePopupSuccess,
  deleteReferancesSuccess,
  addGallerySuccess,
  deleteGallerySuccess,
  deleteCourseSchedulesSuccess,
  deleteDynamicFormSuccess,
  deleteDynamicExtraFormSuccess,

  deleteDynamicExtraExtraFormSuccess,
  getEducationSuccess,
  getSubEducationSuccess,
  updateEducationSuccess,
  addEducationSuccess,
  updateSubEducationSuccess,
  addSubEducationSuccess,
  deleteSubEducationSuccess,
  getProductCategorySuccess,
  getProductSuccess,
  getSlidersSuccess,
  getUsersSuccess,
  getBlogsSuccess,
  addProductCategorySuccess,
  addBlogSuccess,
  addProductSuccess,
  deleteProductSuccess,
  updateProductSuccess,

  addReservationSuccess,
  deleteReservationSuccess,
  updateReservationSuccess,
  getReservationSuccess,
  addAvailableSuccess,
  deleteAvailableSuccess,
  updateAvailableSuccess,
  getAvailableSuccess,
  getCampainHistorySuccessCompany,

  updateCampainHistoryCompanySuccess,
  addCampainHistoryCompanySuccess,
  deleteCampainHistoryCompanySuccess,
  addAuthSuccess,
  deleteAuthSuccess,
  getFeedBackCategorySuccess,
  updateFeedbackCategorySuccess,
  addFeedbackCategorySuccess,
  deleteFeedBackCategorySuccess,
  deleteWebAppSuccess,
  addWebWebAppSuccess,
  getWebAppSuccess,
  updateWebAppSuccess,
  getSubsSuccess,
} from "./actions"

//Include Both Helper File with needed methods
import {
  deleteFeedBackCategory,
  addFeedBackCategory,
  updateFeedbackCategory,
  getFeedBackCategory,
  deleteAuth,
  deleteCompanyReferanceCode,
  updateCompanyReferanceCode,

  getCompanyReferanceCode,
  updateBlogSubCat,deleteBlogSubCat,addBlogSubCat ,getBlogSubCat,
  updateFeedBack,deleteFeedBack,addFeedBack ,getFeedBack,
  updateCampainCategory,deleteCampainCategory,addCampainCategory ,getCampainCategory,
  updateCampain,deleteCampain,addCampain ,getCampain,
  updateCampainHistory,deleteCampainHistory,addCampainHistory ,getCampainHistory,
  deleteCampainPeriod,
  addCampainPeriod,
  getCampainPeriod,
  updateCampainPeriod,
  updateCompany,deleteCompany,addCompany ,getCompany,
  updateJob,deleteJob,addJob ,getJob,
  updateSector,deleteSector,addSector ,getSector,
  updateSubSector,deleteSubSector,addSubSector ,getSubSector,
  updateBlogCat,deleteBlogCat,addBlogCat ,getBlogCat,updateAdvert,deleteAdvert,addAdvert ,getAdvert,updateAvailable,
  deleteAvailable,addAvailable ,getAvailable,updateOffer,deleteOffer,addOffer ,getOffer,updateReservation,deleteReservation,
  addReservation ,getReservation, updateProduct,deleteProduct,addProduct ,updateProductCategory,updateAbout, getSSS,addSSS,
  updateSSS,deleteSSS,getBlogs, getSliders, getCategory, deleteSubEducation, deleteBlog, deleteProductCategory,
   addSubEducation,addBlog, updateSubEducation, addEducation, updateEducation, getEducationSubItem, getEducation,
    deleteDynamicFormExtraExtra, deleteDynamicForm, deleteDynamicFormExtra, deleteCourseSchedules, addMultipleGalleryForm, 
    deleteGallery, addGallerry, addProductCategory, deleteReferances, deletePopup, deleteSlider, deleteNews, deleteMega,
     getDynamicFormExtraExtraMega, getDynamicFormExtraMega, addDynamicForm, updateDynamicForm, getClassesMega, getClassAttendance, 
     updateLessonsTime, addLessonsTime, getTeacherWorkshop, getSubProject, updateReferances, addReferances, getReferances, 
     addWorkshop2, addAppSetting, addNewSubdomain, updateGallery, getGallery, updateWorkShop2, getWorkshop2, updateMega,
      updateProject, updateSlider, updateAuth, getAuthority, updateContact, getContact, getAbout,updateBlog, updateTeacher,
       updateWorkshopSession, updateSubdomain, addCourseMega, updateCourseSchedules, updateNews, addMega, addNews, addProject,
        addSlider, addPopup, getMegaMega, getNews, getProjectsNew, getSlider, getDynamicFormMega, getEventMega, getTeacherMega,
         getWorkshopSessionMega, getPopup, getUsers, getUserProfile, addNewUser,addUser, updateUser, deleteUser, getWorkShop, 
         getCourseSchedulesMega, getProducts1, addCompanyReferanceCode,
         deleteWebApp,
         addWebApp,
         getWebApp,
         updateWebApp,
         getSubs
        } from "../../helpers/fakebackend_helper"


     
         function* onDeleteWebApp({ payload: user }) {
          try {
            const response = yield call(deleteWebApp, user)
            yield put(deleteWebAppSuccess(user,response))
          } catch (error) {
            yield put(deleteUserFail(error))
          }
        }
        function* onAddWebApp({ payload: user }) {
          try {
            const response = yield call(addWebApp, user)
        
            yield put(addWebWebAppSuccess(response.value[0]))
          } catch (error) {
        
            yield put(addUserFail(error))
          }
        }
        
        function* onGetWebApp(item) {
          try {
            const response = yield call(getWebApp, item.users)
            yield put(getWebAppSuccess(response))
          } catch (error) {
            yield put(getUsersFail(error))
          }
        }

        function* onUpdateWebApp({ payload: user }) {
          try {
            const response = yield call(updateWebApp, user)
            
            yield put(updateWebAppSuccess(response.value[0]))
          } catch (error) {
            yield put(updateUserFail(error))
          }
        }

         function* onDeleteCampainHistory({ payload: user }) {
          try {
            const response = yield call(deleteCampainHistory, user)
            yield put(deleteCampainHistorySuccess(user))
          } catch (error) {
            yield put(deleteUserFail(error))
          }
        }
        function* onAddCampainHistory({ payload: user }) {
          try {
            const response = yield call(addCampainHistory, user)
        
            yield put(addCampainHistorySuccess(response.value[0]))
          } catch (error) {
        
            yield put(addUserFail(error))
          }
        }
        



        function* onGetCampainHistory(item) {
          try {
            const response = yield call(getCampainHistory, item.users)
            yield put(getCampainHistorySuccess(response))
          } catch (error) {
            yield put(getUsersFail(error))
          }
        }

        function* onGetCampainHistoryCompany(item) {
          try {
            const response = yield call(getCompanyReferanceCode, item.users)
            yield put(getCampainHistorySuccessCompany(response))
          } catch (error) {
            yield put(getUsersFail(error))
          }
        }
        
        function* onDeleteFeedBackCategory({ payload: user }) {
          try {

            const response = yield call(deleteFeedBackCategory, user)
            yield put(deleteFeedBackCategorySuccess(user,response))
          } catch (error) {
            yield put(deleteUserFail(error))
          }
        }
        
        function* onDeleteAuth({ payload: user }) {
          try {

            const response = yield call(deleteAuth, user)
            yield put(deleteAuthSuccess(user,response))
          } catch (error) {
            yield put(deleteUserFail(error))
          }
        }

        function* onDeleteCampainHistoryCompany({ payload: user }) {
          try {
            const response = yield call(deleteCompanyReferanceCode, user)
            yield put(deleteCampainHistoryCompanySuccess(user,response))
          } catch (error) {
            yield put(deleteUserFail(error))
          }
        }

        function* onAddCampainHistoryCompany({ payload: user }) {
          try {
            const response = yield call(addCompanyReferanceCode, user)

            yield put(addCampainHistoryCompanySuccess(response.value[0]))
          } catch (error) {
        
            yield put(addUserFail(error))
          }
        }
        
        function* onUpdateCampainHistoryCompany({ payload: user }) {
          try {
            const response = yield call(updateCompanyReferanceCode, user)
            
            yield put(updateCampainHistoryCompanySuccess(response.value[0]))
          } catch (error) {
            yield put(updateUserFail(error))
          }
        }

        function* onDeleteCampainPeriod({ payload: user }) {
          try {
            const response = yield call(deleteCampainPeriod, user)
            yield put(deleteCampainPeriodSuccess(user))
          } catch (error) {
            yield put(deleteUserFail(error))
          }
        }

        function* onUpdateCampainHistory({ payload: user }) {
          try {
            const response = yield call(updateCampainHistory, user)
            yield put(updateCampainHistorySuccess(response.value[0]))
          } catch (error) {
            yield put(updateUserFail(error))
          }
        }
      


  function* onAddCampainPeriod({ payload: user }) {
    try {
      const response = yield call(addCampainPeriod, user)
  
      yield put(addCampainPeriodSuccess(response.value[0]))
    } catch (error) {
  
      yield put(addUserFail(error))
    }
  }
  function* onGetCampainPeriod(item) {
    try {
      const response = yield call(getCampainPeriod, item.users)
      yield put(getCampainPeriodSuccess(response))
    } catch (error) {
      yield put(getUsersFail(error))
    }
  }
  function* onUpdateCampainPeriod({ payload: user }) {
    try {
      const response = yield call(updateCampainPeriod, user)
      yield put(updateCampainPeriodSuccess(response.value[0]))
    } catch (error) {
      yield put(updateUserFail(error))
    }
  }







  function* onDeleteSector({ payload: user }) {
    try {
      const response = yield call(deleteSector, user)
      yield put(deleteSectorSuccess(user))
    } catch (error) {
      yield put(deleteUserFail(error))
    }
  }
  function* onAddSector({ payload: user }) {
    try {
      const response = yield call(addSector, user)
  
      yield put(addSectorSuccess(response.value[0]))
    } catch (error) {
  
      yield put(addUserFail(error))
    }
  }
  function* onGetSector(item) {
    try {
      const response = yield call(getSector, item.users)
      yield put(getSectorSuccess(response))
    } catch (error) {
      yield put(getUsersFail(error))
    }
  }
  function* onUpdateSector({ payload: user }) {
    try {
      const response = yield call(updateSector, user)
      yield put(updateSectorSuccess(response.value[0]))
    } catch (error) {
      yield put(updateUserFail(error))
    }
  }




  function* onDeleteSubSector({ payload: user }) {
    try {
      const response = yield call(deleteSubSector, user)
      console.log("user1231",user)
      yield put(deleteSubSectorSuccess(user))
    } catch (error) {
      yield put(deleteUserFail(error))
    }
  }
  function* onAddSubSector({ payload: user }) {
    try {
      const response = yield call(addSubSector, user)
  
      yield put(addSubSectorSuccess(response.value[0]))
    } catch (error) {
  
      yield put(addUserFail(error))
    }
  }
  function* onGetSubSector(item) {
    try {
      const response = yield call(getSubSector, item.users)
      yield put(getSubSectorSuccess(response))
    } catch (error) {
      yield put(getUsersFail(error))
    }
  }
  function* onUpdateSubSector({ payload: user }) {
    try {
      const response = yield call(updateSubSector, user)
      yield put(updateSubSectorSuccess(response.value[0]))
    } catch (error) {
      yield put(updateUserFail(error))
    }
  }

  function* onDeleteJob({ payload: user }) {
    try {
      const response = yield call(deleteJob, user)
      yield put(deleteJobSuccess(user))
    } catch (error) {
      yield put(deleteUserFail(error))
    }
  }
  function* onAddJob({ payload: user }) {
    try {
      const response = yield call(addJob, user)
  
      yield put(addJobSuccess(response.value[0]))
    } catch (error) {
  
      yield put(addUserFail(error))
    }
  }
  function* onGetJob(item) {
    try {
      const response = yield call(getJob, item.users)
      yield put(getJobSuccess(response))
    } catch (error) {
      yield put(getUsersFail(error))
    }
  }
  function* onUpdateJob({ payload: user }) {
    try {
      const response = yield call(updateJob, user)
      yield put(updateJobSuccess(response.value[0]))
    } catch (error) {
      yield put(updateUserFail(error))
    }
  }




  function* onDeleteCampainCategory({ payload: user }) {
    try {
      const response = yield call(deleteCampainCategory, user)
      yield put(deleteCampainCategorySuccess(user))
    } catch (error) {
      yield put(deleteUserFail(error))
    }
  }
  function* onAddCampainCategory({ payload: user }) {
    try {
      const response = yield call(addCampainCategory, user)
  
      yield put(addCampainCategorySuccess(response.value[0]))
    } catch (error) {
  
      yield put(addUserFail(error))
    }
  }
  function* onGetCampainCategory(item) {
    try {
      const response = yield call(getCampainCategory, item.users)
      yield put(getCampainCategorySuccess(response))
    } catch (error) {
      yield put(getUsersFail(error))
    }
  }
  function* onUpdateCampainCategory({ payload: user }) {
    try {
      const response = yield call(updateCampainCategory, user)
      yield put(updateCampainCategorySuccess(response.value[0]))
    } catch (error) {
      yield put(updateUserFail(error))
    }
  }

  function* onDeleteCompany({ payload: user }) {
    try {
      const response = yield call(deleteCompany, user)
      yield put(deleteCompanySuccess(user,response))
    } catch (error) {
      yield put(deleteUserFail(error))
    }
  }
  function* onAddCompany({ payload: user }) {
    try {
      const response = yield call(addCompany, user)
  
      yield put(addCompanySuccess(response.value[0]))
    } catch (error) {
  
      yield put(addUserFail(error))
    }
  }
  function* onGetCompany(item) {
    try {
      const response = yield call(getCompany, item.users)
      yield put(getCompanySuccess(response))
    } catch (error) {
      yield put(getUsersFail(error))
    }
  }
  function* onUpdateCompany({ payload: user }) {
    try {
      const response = yield call(updateCompany, user)
      yield put(updateCompanySuccess(response.value[0]))
    } catch (error) {
      yield put(updateUserFail(error))
    }
  }


  function* onDeleteCampain({ payload: user }) {
    try {
      const response = yield call(deleteCampain, user)
      yield put(deleteCampainSuccess(user))
    } catch (error) {
      yield put(deleteUserFail(error))
    }
  }
  
  function* onAddCampain({ payload: user }) {
    try {
      const response = yield call(addCampain, user)
  
      console.log("ksmdfkş",response.value[0])
      yield put(addCampainSuccess(response.value[0]))
    } catch (error) {
  
      yield put(addUserFail(error))
    }
  }

  
  function* onGetFeedBackCategory(item) {
    try {
      const response = yield call(getFeedBackCategory, item.users)
      yield put(getFeedBackCategorySuccess(response))
    } catch (error) {
      yield put(getUsersFail(error))
    }
  }

  function* onGetCampain(item) {
    try {
      const response = yield call(getCampain, item.users)
      yield put(getCampainSuccess(response))
    } catch (error) {
      yield put(getUsersFail(error))
    }
  }

  function* onUpdateFeedbackCategory({ payload: user }) {
    try {
      const response = yield call(updateFeedbackCategory, user)
      yield put(updateFeedbackCategorySuccess(user,response))
    } catch (error) {
      yield put(updateUserFail(error))
    }
  }


  function* onUpdateCampain({ payload: user }) {
    try {
      const response = yield call(updateCampain, user)
      yield put(updateCampainSuccess(user,response))
    } catch (error) {
      yield put(updateUserFail(error))
    }
  }

  function* onDeleteFeedBack({ payload: user }) {
    try {
      const response = yield call(deleteFeedBack, user)
      yield put(deleteFeedBackSuccess(user))
    } catch (error) {
      yield put(deleteUserFail(error))
    }
  }
  function* onAddFeedBack({ payload: user }) {
    try {
      const response = yield call(addFeedBack, user)
  
      yield put(addFeedBackSuccess(response.value[0]))
    } catch (error) {
  
      yield put(addUserFail(error))
    }
  }

  function* onAddFeedbackCategory({ payload: user }) {
    try {
      const response = yield call(addFeedBackCategory, user)
  
      yield put(addFeedbackCategorySuccess(response.value[0]))
    } catch (error) {
  
      yield put(addUserFail(error))
    }
  }

  function* onGetFeedBack(item) {
    try {
      const response = yield call(getFeedBack, item.users)
      yield put(getFeedBackSuccess(response))
    } catch (error) {
      yield put(getUsersFail(error))
    }
  }
  function* onUpdateFeedBack({ payload: user }) {
    try {
      const response = yield call(updateFeedBack, user)
      yield put(updateFeedBackSuccess(response.value[0]))
    } catch (error) {
      yield put(updateUserFail(error))
    }
  }


  function* onDeleteBlogSubCat({ payload: user }) {
    try {
      const response = yield call(deleteBlogSubCat, user)
      yield put(deleteBlogSubCatSuccess(user))
    } catch (error) {
      yield put(deleteUserFail(error))
    }
  }
  function* onAddBlogSubCat({ payload: user }) {
    try {
      const response = yield call(addBlogSubCat, user)
  
      yield put(addBlogSubCatSuccess(response.value[0]))
    } catch (error) {
  
      yield put(addUserFail(error))
    }
  }
  function* onGetBlogSubCat(item) {
    try {
      const response = yield call(getBlogSubCat, item.users)
      yield put(getBlogSubCatSuccess(response))
    } catch (error) {
      yield put(getUsersFail(error))
    }
  }
  function* onUpdateBlogSubCat({ payload: user }) {
    try {
      const response = yield call(updateBlogSubCat, user)
      yield put(updateBlogSubCatSuccess(response.value[0]))
    } catch (error) {
      yield put(updateUserFail(error))
    }
  }
  
  





function* onDeleteBlogCat({ payload: user }) {
  try {
    const response = yield call(deleteBlogCat, user)
    yield put(deleteBlogCatSuccess(user))
  } catch (error) {
    yield put(deleteUserFail(error))
  }
}
function* onAddBlogCat({ payload: user }) {
  try {
    const response = yield call(addBlogCat, user)

    yield put(addBlogCatSuccess(response.value[0]))
  } catch (error) {

    yield put(addUserFail(error))
  }
}
function* onGetBlogCat(item) {
  try {
    const response = yield call(getBlogCat, item.users)
    yield put(getBlogCatSuccess(response))
  } catch (error) {
    yield put(getUsersFail(error))
  }
}
function* onUpdateBlogCat({ payload: user }) {
  try {
    const response = yield call(updateBlogCat, user)
    yield put(updateBlogCatSuccess(response.value[0]))
  } catch (error) {
    yield put(updateUserFail(error))
  }
}








function* onDeleteAdvert({ payload: user }) {
  try {
    const response = yield call(deleteAdvert, user)
    yield put(deleteAdvertSuccess(user))
  } catch (error) {
    yield put(deleteUserFail(error))
  }
}
function* onAddAdvert({ payload: user }) {
  try {
    const response = yield call(addAdvert, user)

    yield put(addAdvertSuccess(response.value[0]))
  } catch (error) {

    yield put(addUserFail(error))
  }
}
function* onGetAdvert(item) {
  try {
    const response = yield call(getAdvert, item.users)
    yield put(getAdvertSuccess(response))
  } catch (error) {
    yield put(getUsersFail(error))
  }
}
function* onUpdateAdvert({ payload: user }) {
  try {
    const response = yield call(updateAdvert, user)
    yield put(updateAdvertSuccess(response.value[0]))
  } catch (error) {
    yield put(updateUserFail(error))
  }
}







function* onDeleteSubEducation({ payload: user }) {
  try {
    const response = yield call(deleteSubEducation, user)
    yield put(deleteSubEducationSuccess(user))
  } catch (error) {
    yield put(deleteUserFail(error))
  }
}

function* onDeleteAvailable({ payload: user }) {
  try {
    const response = yield call(deleteAvailable, user)
    yield put(deleteAvailableSuccess(user))
  } catch (error) {
    yield put(deleteUserFail(error))
  }
}
function* onAddAvailable({ payload: user }) {
  try {
    const response = yield call(addAvailable, user)

    yield put(addAvailableSuccess(response.value[0]))
  } catch (error) {

    yield put(addUserFail(error))
  }
}
function* onGetAvailable(item) {
  try {
    console.log("msdlşf",item.startDate,item.finishDate)
    const response = yield call(getAvailable, item.startDate,item.finishDate)
    yield put(getAvailableSuccess(response))
  } catch (error) {
    yield put(getUsersFail(error))
  }
}
function* onUpdateAvailable({ payload: user }) {
  try {
    const response = yield call(updateAvailable, user)
    yield put(updateAvailableSuccess(response.value[0]))
  } catch (error) {
    yield put(updateUserFail(error))
  }
}







function* onDeleteOffer({ payload: user }) {
  try {
    const response = yield call(deleteOffer, user)
    yield put(deleteOfferSuccess(user))
  } catch (error) {
    yield put(deleteUserFail(error))
  }
}
function* onAddOffer({ payload: user }) {
  try {
    const response = yield call(addOffer, user)

    yield put(addReservationSuccess(response.value[0]))
  } catch (error) {

    yield put(addUserFail(error))
  }
}
function* onGetOffer(item) {
  try {
    const response = yield call(getOffer, item.users)
    yield put(getOfferSuccess(response))
  } catch (error) {
    yield put(getUsersFail(error))
  }
}
function* onUpdateOffer({ payload: user }) {
  try {
    const response = yield call(updateOffer, user)
    yield put(updateOfferSuccess(response.value[0]))
  } catch (error) {
    yield put(updateUserFail(error))
  }
}


function* onDeleteReservation({ payload: user }) {
  try {
    const response = yield call(deleteReservation, user)
    yield put(deleteReservationSuccess(user))
  } catch (error) {
    yield put(deleteUserFail(error))
  }
}
function* onAddReservation({ payload: user }) {
  try {
    const response = yield call(addReservation, user)

    yield put(addReservationSuccess(response.value[0]))
  } catch (error) {

    yield put(addUserFail(error))
  }
}
function* onGetReservation(item) {
  try {
    const response = yield call(getReservation, item.users)
    yield put(getReservationSuccess(response))
  } catch (error) {
    yield put(getUsersFail(error))
  }
}
function* onUpdateReservation({ payload: user }) {
  try {
    const response = yield call(updateReservation, user)
    yield put(updateReservationSuccess(response.value[0]))
  } catch (error) {
    yield put(updateUserFail(error))
  }
}


function* onDeleteProduct({ payload: user }) {
  try {
    const response = yield call(deleteProduct, user)
    yield put(deleteProductSuccess(user))
  } catch (error) {
    yield put(deleteUserFail(error))
  }
}

function* onAddProduct({ payload: user }) {

  try {
    const response = yield call(addProduct, user)

    yield put(addProductSuccess(response.value[0]))
  } catch (error) {

    yield put(addUserFail(error))
  }
}


function* onUpdateProduct({ payload: user }) {
  try {
    const response = yield call(updateProduct, user)
    yield put(updateProductSuccess(response.value[0]))
  } catch (error) {
    yield put(updateUserFail(error))
  }
}


function* onDeleteSss({ payload: user }) {
  try {
    const response = yield call(deleteSSS, user)
    yield put(deleteSSSSuccess(user))
  } catch (error) {
    yield put(deleteUserFail(error))
  }
}

function* onAddSSS({ payload: user }) {

  try {
    const response = yield call(addSSS, user)

    yield put(addSSSSuccess(response.value[0]))
  } catch (error) {

    yield put(addUserFail(error))
  }
}

function* onUpdateSSS({ payload: user }) {
  try {
    const response = yield call(updateSSS, user)
    yield put(updateSSSSuccess(response.value[0]))
  } catch (error) {
    yield put(updateUserFail(error))
  }
}

function* onGetSSS(item) {
  try {
    const response = yield call(getSSS, item.users)
    yield put(getSSSSuccess(response))
  } catch (error) {
    yield put(getUsersFail(error))
  }
}






function* onAddSubEducation({ payload: user }) {

  try {
    const response = yield call(addSubEducation, user)

    yield put(addSubEducationSuccess(response.value[0]))
  } catch (error) {

    yield put(addUserFail(error))
  }
}


function* onUpdateSubEducation({ payload: user }) {
  try {
    const response = yield call(updateSubEducation, user)
    yield put(updateSubEducationSuccess(response.value[0]))
  } catch (error) {
    yield put(updateUserFail(error))
  }
}

function* onUpdateEducation({ payload: user }) {
  try {
    const response = yield call(updateEducation, user)
    yield put(updateEducationSuccess(response.value[0]))
  } catch (error) {
    yield put(updateUserFail(error))
  }
}


function* onUpdateContact({ payload: user }) {
  try {
    const response = yield call(updateContact, user)
    yield put(updateContactSuccess(response.value[0]))
  } catch (error) {
    yield put(updateUserFail(error))
  }
}

function* onUpdateAbout({ payload: user }) {
  try {
    const response = yield call(updateAbout, user)
    yield put(updateAboutSuccess(response.value[0]))
  } catch (error) {
    yield put(updateUserFail(error))
  }
}

function* onUpdateDynamicForm({ payload: user }) {
  try {
    const response = yield call(updateDynamicForm, user)
    yield put(updateDynamicFormSuccess(response.value[0]))
  } catch (error) {
    yield put(updateUserFail(error))
  }
}

function* onGetEducationSubItem(item) {
  try {

    console.log("kdsmcşlf",item.payload)
    const response = yield call(getEducationSubItem, item.payload)
    yield put(getSubEducationSuccess(response))
  } catch (error) {
    yield put(getUsersFail(error))
  }
}

function* onGetEducation(item) {
  try {
    const response = yield call(getEducation, item.users)
    yield put(getEducationSuccess(response))
  } catch (error) {
    yield put(getUsersFail(error))
  }
}

function* ongetProductCategory(item) {
  try {
    const response = yield call(getCategory, item.users)
    console.log("response", response)
    yield put(getProductCategorySuccess(response))
  } catch (error) {
    yield put(getUsersFail(error))
  }
}


function* onGetProduct(item) {
  try {
    const response = yield call(getProducts1, item.users)
    yield put(getProductSuccess(response))
  } catch (error) {
    yield put(getUsersFail(error))
  }
}


function* onGetSliders(item) {
  try {
    const response = yield call(getSliders, item.users)
    yield put(getSlidersSuccess(response))
  } catch (error) {
    yield put(getUsersFail(error))
  }
}


function* onGetSubs(item) {
  try {
    const response = yield call(getSubs, item.users)
    yield put(getSubsSuccess(response))
  } catch (error) {
    yield put(getUsersFail(error))
  }
}


function* onUpdateBlog({ payload: user }) {
  try {
    const response = yield call(updateBlog, user)
    yield put(updateBlogSuccess(response.value[0]))
  } catch (error) {
    yield put(updateUserFail(error))
  }
}


function* onAddBlog({ payload: user }) {

  try {
    const response = yield call(addBlog, user)

    yield put(addBlogSuccess(response.value[0]))
  } catch (error) {

    yield put(addUserFail(error))
  }
}

function* onDeleteBlog({ payload: user }) {
  try {
    const response = yield call(deleteBlog, user)
    yield put(deleteBlogSuccess(user,response))
  } catch (error) {
    yield put(deleteUserFail(error))
  }
}

function* onGetBlogs(item) {
  try {
    const response = yield call(getBlogs, item.users)
    console.log("kbsdf", response)
    yield put(getBlogsSuccess(response))
  } catch (error) {
    yield put(getUsersFail(error))
  }
}



function* onGetUsers(item) {
  try {
    
   
      const response = yield call(getUsers, item.users)
      console.log("sdfömslkfsmşf",response)
      yield put(getUsersSuccess(response))
  
 
  } catch (error) {
    console.log("sdfömslkerrorfsmşf",error)

    yield put(getUsersFail(error))
  }
}

function* onGetDynamicFormExtraExtra(item) {
  try {
    const response = yield call(getDynamicFormExtraExtraMega, item.users)
    yield put(getDynamicFormExtraExtraSuccess(response))
  } catch (error) {
    yield put(getUsersFail(error))
  }
}

function* onGetDynamicFormExtra(item) {
  try {
    const response = yield call(getDynamicFormExtraMega, item.users)
    yield put(getDynamicFormExtraSuccess(response))
  } catch (error) {
    yield put(getUsersFail(error))
  }
}

function* onGetClasses() {
  try {
    const response = yield call(getClassesMega)
    yield put(getClassesSuccess(response))
  } catch (error) {
    yield put(getUsersFail(error))
  }
}

function* onGetClassAttendance() {
  try {
    const response = yield call(getClassAttendance)
    yield put(getClassAttendanceSuccess(response))
  } catch (error) {
    yield put(getUsersFail(error))
  }
}


function* onGetTeacherWorkshopMega() {
  try {
    const response = yield call(getTeacherWorkshop)
    yield put(getTeacherWorkshopSuccess(response))
  } catch (error) {
    yield put(getUsersFail(error))
  }
}

function* onGetSubProject(item) {
  try {
    const response = yield call(getSubProject(item.news))
    yield put(getSubProjectSuccess(response))
  } catch (error) {
    yield put(getUsersFail(error))
  }
}

function* onUpdateLessonsTime({ payload: user }) {
  try {
    const response = yield call(updateLessonsTime, user)
    yield put(updateLessonsTimeSuccess(response))
  } catch (error) {
    yield put(updateUserFail(error))
  }
}



function* onAddEducation({ payload: user }) {

  try {
    const response = yield call(addEducation, user)

    yield put(addEducationSuccess(response.value[0]))
  } catch (error) {

    yield put(addUserFail(error))
  }
}





function* onAddLessonsTime({ payload: user }) {

  try {
    const response = yield call(addLessonsTime, user)

    yield put(addSuccessLessonsTime(response.value[0]))
  } catch (error) {

    yield put(addUserFail(error))
  }
}

function* onAddReferances({ payload: user }) {

  try {
    const response = yield call(addReferances, user)

    yield put(addSuccessReferances(response.value[0]))
  } catch (error) {

    yield put(addUserFail(error))
  }
}

function* onGetReferances() {
  try {
    const response = yield call(getReferances)
    yield put(getReferancesSuccess(response))
  } catch (error) {
    yield put(getUsersFail(error))
  }
}

function* fetchGallery() {
  try {
    const response = yield call(getGallery)
    yield put(getGallerySuccess(response))
  } catch (error) {
    yield put(getUsersFail(error))
  }
}


function* fetchAuthority() {
  try {
    const response = yield call(getAuthority)
    yield put(getAuthSuccess(response))
  } catch (error) {
    yield put(getUsersFail(error))
  }
}

function* fetchContact() {
  try {
    const response = yield call(getContact)
    yield put(getMegaSuccess(response))
  } catch (error) {
    yield put(getUsersFail(error))
  }
}

function* fetchAbout() {
  try {
    const response = yield call(getAbout)
    yield put(getAboutSuccess(response))
  } catch (error) {
    yield put(getUsersFail(error))
  }
}

function* onUpdateAuth({ payload: user }) {
  try {
    const response = yield call(updateAuth, user)
    yield put(getAuthUpdateSuccess(response))
  } catch (error) {
    yield put(updateUserFail(error))
  }
}


function* onUpdateReferances({ payload: user }) {
  try {
    const response = yield call(updateReferances, user)
    yield put(updateSuccessReferances(response.value[0]))
  } catch (error) {
    yield put(updateUserFail(error))
  }
}

function* onUpdateProject({ payload: user }) {
  try {
    const response = yield call(updateProject, user)
    yield put(updateSuccessProject(response.value[0]))
  } catch (error) {
    yield put(updateUserFail(error))
  }
}





function* onUpdateProductCategory({ payload: user }) {
  try {
    const response = yield call(updateProductCategory, user)
    console.log("jlnsdfl", response)
    yield put(updateSuccessProductCategory(response.value[0]))
  } catch (error) {
    yield put(updateUserFail(error))
  }
}




function* onUpdateTeacher({ payload: user }) {
  try {
    const response = yield call(updateTeacher, user)
    yield put(updateTeacherSuccess(response.value[0]))
  } catch (error) {
    yield put(updateUserFail(error))
  }
}

function* onUpdateWorkshopSession({ payload: user }) {
  try {
    const response = yield call(updateWorkshopSession, user)
    yield put(updateWorkShopSessionSuccess(response.value[0]))
  } catch (error) {
    yield put(updateUserFail(error))
  }
}


function* onUpdateSlider({ payload: user }) {
  try {
    const response = yield call(updateSlider, user)
    yield put(updateSliderSuccess(response.value[0]))
  } catch (error) {
    yield put(updateUserFail(error))
  }
}

function* onUpdateSubdomain({ payload: user }) {
  try {
    const response = yield call(updateSubdomain, user)
    yield put(updateSubdomainSuccess(response.value[0]))
  } catch (error) {
    yield put(updateUserFail(error))
  }
}


function* fetchMega() {
  try {
    const response = yield call(getMegaMega)
    yield put(getMegaSuccess(response))
  } catch (error) {
    yield put(getUsersFail(error))
  }
}

function* fetchNews() {
  try {
    const response = yield call(getNews)
    yield put(getNewsSuccess(response))
  } catch (error) {
    yield put(getUsersFail(error))
  }
}


function* fetchProjects() {
  try {
    const response = yield call(getProjectsNew)
    yield put(getProjectSuccess(response))
  } catch (error) {
    yield put(getUsersFail(error))
  }
}


function* fetchSlider() {
  try {
    const response = yield call(getSlider)
    yield put(getSliderSuccess(response))
  } catch (error) {
    yield put(getUsersFail(error))
  }
}


function* fetcDynamicFormMega() {
  try {
    const response = yield call(getDynamicFormMega)
    yield put(getDynamicSuccess(response))
  } catch (error) {
    yield put(getUsersFail(error))
  }
}

function* fetcEventMega() {
  try {
    const response = yield call(getEventMega)
    yield put(getUsersSuccess(response))
  } catch (error) {
    yield put(getUsersFail(error))
  }
}

function* fetcTeacherMega() {
  try {
    const response = yield call(getTeacherMega)
    yield put(getTeacherSuccess(response))
  } catch (error) {
    yield put(getUsersFail(error))
  }
}

function* fetchWorkshopSessionMega() {
  try {
    const response = yield call(getWorkshopSessionMega)
    yield put(getApplicationSuccess(response))
  } catch (error) {
    yield put(getUsersFail(error))
  }
}
function* fetchCourseSchedulesMega() {
  try {
    const response = yield call(getCourseSchedulesMega)
    yield put(getWorkshopSessionSuccess(response))
  } catch (error) {
    yield put(getUsersFail(error))
  }
}

function* fetchWorkshop2() {
  try {
    const response = yield call(getWorkshop2)
    yield put(getWorkshop2Success(response))
  } catch (error) {
    yield put(getUsersFail(error))
  }
}

function* fetchPopup(item) {
  try {
    console.log("item123", item)

    const response = yield call(getPopup, item.users)
    console.log("response123", response)
    yield put(getPopupSuccess(response))
  } catch (error) {
    yield put(getUsersFail(error))
  }
}

function* fetchWorkshop() {
  try {
    const response = yield call(getWorkShop)
    yield put(getWorkshopSuccess(response))
  } catch (error) {
    yield put(getUsersFail(error))
  }
}

function* fetchUsers() {
  try {
    const response = yield call(getUsers)
    yield put(getUsersSuccess(response))
  } catch (error) {
    yield put(getUsersFail(error))
  }
}

function* fetchUserProfile() {
  try {
    const response = yield call(getUserProfile)
    yield put(getUserProfileSuccess(response))
  } catch (error) {
    yield put(getUserProfileFail(error))
  }
}

function* onUpdateCourseSchedules({ payload: user }) {
  try {
    const response = yield call(updateCourseSchedules, user)
    yield put(updateSuccessCourseSchedules(response.value[0]))
  } catch (error) {
    yield put(updateUserFail(error))
  }
}

function* onUpdateNews({ payload: user }) {
  try {
    const response = yield call(updateNews, user)
    yield put(updateNewsSuccess(response.value[0]))
  } catch (error) {
    yield put(updateUserFail(error))
  }
}

function* onUpdateGalllery({ payload: user }) {
  try {
    const response = yield call(updateGallery, user)
    yield put(updateGallerySuccess(response.value[0]))
  } catch (error) {
    yield put(updateUserFail(error))
  }
}

function* onUpdateWorkshop2({ payload: user }) {
  try {
    const response = yield call(updateWorkShop2, user)
    yield put(updateWorkShop2Success(response.value[0]))
  } catch (error) {
    yield put(updateUserFail(error))
  }
}

function* onUpdateMega({ payload: user }) {
  try {
    const response = yield call(updateMega, user)
    yield put(updateMegaSuccess(response.value[0]))
  } catch (error) {
    yield put(updateUserFail(error))
  }
}

function* onUpdateUser({ payload: user }) {
  try {
    const response = yield call(updateUser, user)
    yield put(updateUserSuccess(response.value[0]))
  } catch (error) {
    yield put(updateUserFail(error))
  }
}

function* onDeleteUser({ payload: user }) {
  try {
    const response = yield call(deleteUser, user)
    console.log("klsmdfklds", response, user)
    yield put(deleteUserSuccess(response, user))
  } catch (error) {
    yield put(deleteUserFail(error))
  }
}




function* onAddDynamicForm({ payload: user }) {

  try {
    const response = yield call(addDynamicForm, user)

    yield put(addDynamicFormSuccess(response.value[0]))
  } catch (error) {

    yield put(addUserFail(error))
  }
}

function* onAdddNewWorkshop2({ payload: user }) {

  try {
    const response = yield call(addWorkshop2, user)

    yield put(addUserSuccess(response))
  } catch (error) {

    yield put(addUserFail(error))
  }
}

function* onAddWorkshopSession({ payload: user }) {

  try {
    const response = yield call(addAppSetting, user)

    yield put(addUserSuccess(response))
  } catch (error) {

    yield put(addUserFail(error))
  }
}

function* onAddWorkshopSubdomain({ payload: user }) {

  try {
    const response = yield call(addNewSubdomain, user)

    yield put(addUserSuccess(response))
  } catch (error) {

    yield put(addUserFail(error))
  }
}



function* onAddCourse({ payload: user }) {

  try {
    const response = yield call(addCourseMega, user)

    yield put(addUserSuccess(response))
  } catch (error) {

    yield put(addUserFail(error))
  }
}
function* onAddNewMega({ payload: user }) {

  try {
    const response = yield call(addMega, user)

    yield put(addMegaSuccess(response.value[0]))
  } catch (error) {

    yield put(addUserFail(error))
  }
}

function* onAddNews({ payload: user }) {

  try {
    const response = yield call(addNews, user)

    yield put(addUserSuccess(response))
  } catch (error) {

    yield put(addUserFail(error))
  }
}

function* onAddProject({ payload: user }) {

  try {
    const response = yield call(addProject, user)

    yield put(addUserSuccess(response))
  } catch (error) {

    yield put(addUserFail(error))
  }
}
function* onAddSlider({ payload: user }) {

  try {
    const response = yield call(addSlider, user)

    console.log("şlmsşdlf",response)
    yield put(addSliderSuccess(response))
  } catch (error) {

    yield put(addUserFail(error))
  }
}

function* onAddPopup({ payload: user }) {

  try {
    const response = yield call(addPopup, user)

    yield put(addUserSuccess(response))
  } catch (error) {

    yield put(addUserFail(error))
  }
}

function* onDeleteMega({ payload: user }) {
  try {
    const response = yield call(deleteMega, user)
    yield put(deleteMegaSuccess(response, user))
  } catch (error) {
    yield put(deleteUserFail(error))
  }
}

function* onDeleteProductCategory({ payload: user }) {
  try {
    const response = yield call(deleteProductCategory, user)
    yield put(deleteProductCategorySuccess(response, user))
  } catch (error) {
    yield put(deleteUserFail(error))
  }
}

function* onDeleteNews({ payload: user }) {
  try {
    const response = yield call(deleteNews, user)
    yield put(deleteNewsSuccess(response, user))
  } catch (error) {
    yield put(deleteUserFail(error))
  }
}

function* onDeleteSlider({ payload: user }) {
  try {
    const response = yield call(deleteSlider, user)
    yield put(deleteSliderSuccess(response, user))
  } catch (error) {
    yield put(deleteUserFail(error))
  }
}

function* onDeletePopup({ payload: user }) {
  try {
    const response = yield call(deletePopup, user)
    yield put(deletePopupSuccess(response, user))
  } catch (error) {
    yield put(deleteUserFail(error))
  }
}

function* onDeleteReferance({ payload: user }) {
  try {
    const response = yield call(deleteReferances, user)
    yield put(deleteReferancesSuccess(response, user))
  } catch (error) {
    yield put(deleteUserFail(error))
  }
}


function* onAddGallery({ payload: user }) {

  try {
    const response = yield call(addGallerry, user)

    yield put(addGallerySuccess(response.value[0]))
  } catch (error) {

    yield put(addUserFail(error))
  }
}


function* onAddProductCategory({ payload: user }) {

  try {
    const response = yield call(addProductCategory, user)

    yield put(addProductCategorySuccess(response.value[0]))
  } catch (error) {

    yield put(addUserFail(error))
  }
}



function* onAddNewUser({ payload: user }) {

  try {
    const response = yield call(addNewUser, user)

    yield put(addAuthSuccess(response.value[0]))
  } catch (error) {

    yield put(addUserFail(error))
  }
}

function* onAddUser({ payload: user }) {

  try {
    const response = yield call(addUser, user)
    console.log("response123",response)
    yield put(addUserSuccess1(response[0]))
  } catch (error) {

    yield put(addUserFail(error))
  }
}





function* onDeleteGallery({ payload: user }) {
  try {
    const response = yield call(deleteGallery, user)
    yield put(deleteGallerySuccess(response, user))
  } catch (error) {
    yield put(deleteUserFail(error))
  }
}

function* onAddMultipleGallery({ payload: user }) {

  try {
    const response = yield call(addMultipleGalleryForm, user)

    //yield put(addGallerySuccess(response.value[0]))
  } catch (error) {

    yield put(addUserFail(error))
  }
}


function* onDeleteCourseSchedules({ payload: user }) {
  try {
    const response = yield call(deleteCourseSchedules, user)
    yield put(deleteCourseSchedulesSuccess(response, user))
  } catch (error) {
    yield put(deleteUserFail(error))
  }
}

function* onDeleteDynamicFormExtra({ payload: user }) {
  try {
    const response = yield call(deleteDynamicFormExtra, user)
    yield put(deleteDynamicExtraFormSuccess(response, user))
  } catch (error) {
    yield put(deleteUserFail(error))
  }
}

function* onDeleteDynamicForm({ payload: user }) {
  try {
    const response = yield call(deleteDynamicForm, user)
    yield put(deleteDynamicFormSuccess(response, user))
  } catch (error) {
    yield put(deleteUserFail(error))
  }
}

function* onDeleteDynamicFormExtraExtra({ payload: user }) {
  try {
    const response = yield call(deleteDynamicFormExtraExtra, user)
    yield put(deleteDynamicExtraExtraFormSuccess(response, user))
  } catch (error) {
    yield put(deleteUserFail(error))
  }
}

function* contactsSaga() {
  
  yield takeEvery(GET_SUBS, onGetSubs)

yield takeEvery(ADD_WEBAPP, onAddWebApp)

yield takeEvery(UPDATE_WEBAPP, onUpdateWebApp)

yield takeEvery(GET_WEBAPP, onGetWebApp)

yield takeEvery(DELETE_WEBAPP, onDeleteWebApp)


  yield takeEvery(ADD_FEEDBACKCATEGORY, onAddFeedbackCategory)

  yield takeEvery(UPDATE_FEEDBACKCATEGORY, onUpdateFeedbackCategory)

  yield takeEvery(GET_FEEDBACKCATEGORY, onGetFeedBackCategory)

  yield takeEvery(DELETE_CAMPAINCOMPANY_HISTORY, onDeleteCampainHistoryCompany)
  yield takeEvery(ADD_CAMPAINCOMPANY_HISTORY, onAddCampainHistoryCompany)
  yield takeEvery(UPDATE_CAMPAINCOMPANY_HISTORY, onUpdateCampainHistoryCompany)


  yield takeEvery(GET_BLOGCAT, onGetBlogCat)
  yield takeEvery(DELETE_BLOGCAT, onDeleteBlogCat)
  yield takeEvery(DELETE_AUTH, onDeleteAuth)
  yield takeEvery(DELETE_FEEDBACKCATEGORY, onDeleteFeedBackCategory)

  
  yield takeEvery(ADD_BLOGCAT, onAddBlogCat)

  yield takeEvery(UPDATE_BLOGCAT, onUpdateBlogCat)

  
  yield takeEvery(GET_BLOGSUBCAT, onGetBlogSubCat)
  yield takeEvery(DELETE_BLOGSUBCAT, onDeleteBlogSubCat)

  yield takeEvery(ADD_BLOGSUBCAT, onAddBlogSubCat)

  yield takeEvery(UPDATE_BLOGSUBCAT, onUpdateBlogSubCat)



  yield takeEvery(GET_RESERVATION, onGetReservation)
  yield takeEvery(DELETE_RESERVATION, onDeleteReservation)

  yield takeEvery(ADD_RESERVATION, onAddReservation)

  yield takeEvery(UPDATE_RESERVATION, onUpdateReservation)




  yield takeEvery(GET_ADVERT, onGetAdvert)
  yield takeEvery(DELETE_ADVERT, onDeleteAdvert)

  yield takeEvery(ADD_ADVERT, onAddAdvert)

  yield takeEvery(UPDATE_ADVERT, onUpdateAdvert)





  
  yield takeEvery(GET_CAMPAINCOMPANY_HISTORY, onGetCampainHistoryCompany)

  yield takeEvery(GET_CAMPAIN, onGetCampain)
  yield takeEvery(DELETE_CAMPAIN, onDeleteCampain)

  yield takeEvery(ADD_CAMPAIN, onAddCampain)

  yield takeEvery(UPDATE_CAMPAIN, onUpdateCampain)


  yield takeEvery(GET_CAMPAIN_HISTORY, onGetCampainHistory)
  yield takeEvery(DELETE_CAMPAIN_HISTORY, onDeleteCampainHistory)

  yield takeEvery(ADD_CAMPAIN_HISTORY, onAddCampainHistory)

  yield takeEvery(UPDATE_CAMPAIN_HISTORY, onUpdateCampainHistory)



  yield takeEvery(GET_CAMPAINCATEGORY, onGetCampainCategory)
  yield takeEvery(DELETE_CAMPAINCATEGORY, onDeleteCampainCategory)
  yield takeEvery(ADD_CAMPAINCATEGORY, onAddCampainCategory)
  yield takeEvery(UPDATE_CAMPAINCATEGORY, onUpdateCampainCategory)




  yield takeEvery(GET_COMPANY, onGetCompany)
  yield takeEvery(DELETE_COMPANY, onDeleteCompany)
  yield takeEvery(ADD_COMPANY, onAddCompany)
  yield takeEvery(UPDATE_COMPANY, onUpdateCompany)


  yield takeEvery(GET_SECTOR, onGetSector)
  yield takeEvery(DELETE_SECTOR, onDeleteSector)
  yield takeEvery(ADD_SECTOR, onAddSector)
  yield takeEvery(UPDATE_SECTOR, onUpdateSector)



  yield takeEvery(GET_SUBSECTOR, onGetSubSector)
  yield takeEvery(DELETE_SUBSECTOR, onDeleteSubSector)
  yield takeEvery(ADD_SUBSECTOR, onAddSubSector)
  yield takeEvery(UPDATE_SUBSECTOR, onUpdateSubSector)

  yield takeEvery(GET_JOB, onGetJob)
  yield takeEvery(DELETE_JOB, onDeleteJob)
  yield takeEvery(ADD_JOB, onAddJob)
  yield takeEvery(UPDATE_JOB, onUpdateJob)


  yield takeEvery(GET_FEEDBACK, onGetFeedBack)
  yield takeEvery(DELETE_FEEDBACK, onDeleteFeedBack)
  yield takeEvery(ADD_FEEDBACK, onAddFeedBack)
  yield takeEvery(UPDATE_FEEDBACK, onUpdateFeedBack)


  yield takeEvery(GET_CAMPAINPERIOD, onGetCampainPeriod)
  yield takeEvery(DELETE_CAMPAINPERIOD, onDeleteCampainPeriod)

  yield takeEvery(ADD_CAMPAINPERIOD, onAddCampainPeriod)

  yield takeEvery(UPDATE_CAMPAINPERIOD,onUpdateCampainPeriod)




  yield takeEvery(GET_AVAILABLE, onGetAvailable)
  yield takeEvery(DELETE_AVAILABLE, onDeleteAvailable)

  yield takeEvery(ADD_AVAILABLE, onAddAvailable)

  yield takeEvery(UPDATE_AVAILABLE, onUpdateAvailable)


  yield takeEvery(DELETE_SUBEDUCATION, onDeleteSubEducation)


  yield takeEvery(DELETE_PRODUCT, onDeleteProduct)
  yield takeEvery(ADD_PRODUCT, onAddProduct)

  yield takeEvery(UPDATE_PRODUCT, onUpdateProduct)

  

  yield takeEvery(DELETE_BLOG, onDeleteBlog)

  yield takeEvery(DELETE_SSS, onDeleteSss)
  yield takeEvery(ADD_SSS, onAddSSS)
  yield takeEvery(GET_SSS, onGetSSS)
  yield takeEvery(UPDATE_SSS, onUpdateSSS)


  yield takeEvery(DELETE_OFFER, onDeleteOffer)
  yield takeEvery(ADD_OFFER, onAddOffer)
  yield takeEvery(GET_OFFER, onGetOffer)
  yield takeEvery(UPDATE_OFFER, onUpdateOffer)

  yield takeEvery(ADD_SUBEDUCATION, onAddSubEducation)

  yield takeEvery(UPDATE_SUBEDUCATION, onUpdateSubEducation)

  yield takeEvery(ADD_EDUCATION, onAddEducation)

  yield takeEvery(UPDATE_EDUCATION, onUpdateEducation)

  yield takeEvery(GET_SUBEDUCATION, onGetEducationSubItem)

  yield takeEvery(GET_EDUCATION, onGetEducation)
  yield takeEvery(GET_PRODUCTCATEGORY, ongetProductCategory)

  yield takeEvery(GET_PRODUCT, onGetProduct)

  yield takeEvery(GET_SLİDERS, onGetSliders)
  yield takeEvery(GET_BLOGS, onGetBlogs)

  yield takeEvery(GET_USERS, onGetUsers)

  yield takeEvery(DELETE_DYNAMICFORMEXTRAEXTRA, onDeleteDynamicFormExtraExtra)

  yield takeEvery(DELETE_DYNAMICFORM, onDeleteDynamicForm)

  yield takeEvery(DELETE_DYNAMICFORMEXTRA, onDeleteDynamicFormExtra)

  yield takeEvery(DELETE_COURSESCHEDULES, onDeleteCourseSchedules)

  yield takeEvery(ADD_GALLERYMULTIPLE, onAddMultipleGallery)

  yield takeEvery(DELETE_GALLERY, onDeleteGallery)

  yield takeEvery(ADD_GALLERY, onAddGallery)


  yield takeEvery(ADD_PRODUCTCATEGORY, onAddProductCategory)

  yield takeEvery(ADD_BLOG, onAddBlog)

  yield takeEvery(DELETE_REFERANCES, onDeleteReferance)

  yield takeEvery(DELETE_POPUP, onDeletePopup)

  yield takeEvery(DELETE_SLIDER, onDeleteSlider)

  yield takeEvery(DELETE_NEWS, onDeleteNews)

  yield takeEvery(DELETE_MEGA, onDeleteMega)
  yield takeEvery(DELETE_PRODUCTCATEGORY, onDeleteProductCategory)

  yield takeEvery(GET_DYNAMICFORM_EXTRA_EXTRA, onGetDynamicFormExtraExtra)

  yield takeEvery(GET_DYNAMICFORM_EXTRA, onGetDynamicFormExtra)

  yield takeEvery(ADD_DYNAMIC_FORM, onAddDynamicForm)

  yield takeEvery(UPDATE_DYNAMICFORM, onUpdateDynamicForm)

  yield takeEvery(GET_CLASSES, onGetClasses)

  yield takeEvery(GET_CLASSATTENDANCE, onGetClassAttendance)

  yield takeEvery(UPDATE_LESSONS_TIME, onUpdateLessonsTime)

  yield takeEvery(ADD_LESSONS_TIME, onAddLessonsTime)

  yield takeEvery(GET_TEACHER_WORKSHOP, onGetTeacherWorkshopMega)

  yield takeEvery(GET_SUBPROJECT, onGetSubProject)

  yield takeEvery(UPDATE_REFERANCES, onUpdateReferances)

  yield takeEvery(ADD_REFERANCES, onAddReferances)

  yield takeEvery(GET_REFERANCES, onGetReferances)

  yield takeEvery(ADD_WORKSHOP2, onAdddNewWorkshop2)

  yield takeEvery(ADD_APPSETTING, onAddWorkshopSession)

  yield takeEvery(ADD_WORKSHOPSUBDOMAIN, onAddWorkshopSubdomain)

  yield takeEvery(UPDATE_GALLERY, onUpdateGalllery)

  yield takeEvery(GET_GALLERY, fetchGallery)

  yield takeEvery(UPDATE_WORKSHOP2, onUpdateWorkshop2)

  yield takeEvery(GET_WORKSHOP2, fetchWorkshop2)

  yield takeEvery(UPDATE_MEGA, onUpdateMega)

  yield takeEvery(UPDATE_PROJECT, onUpdateProject)

  yield takeEvery(UPDATE_BLOG, onUpdateBlog)
  yield takeEvery(UPDATE_PRODUCTCATEGORY, onUpdateProductCategory)

  yield takeEvery(UPDATE_SLIDER, onUpdateSlider)

  yield takeEvery(UPDATE_COURSESCHEDULES, onUpdateCourseSchedules)

  yield takeEvery(UPDATE_AUTH, onUpdateAuth)

  yield takeEvery(GET_AUTHORITY, fetchAuthority)

  yield takeEvery(UPDATE_CONTACT, onUpdateContact)

  yield takeEvery(UPDATE_ABOUT, onUpdateAbout)

  yield takeEvery(GET_CONTACT, fetchContact)
  yield takeEvery(GET_ABOUT, fetchAbout)

  yield takeEvery(UPDATE_TEACHER, onUpdateTeacher)

  yield takeEvery(UPDATE_WORKSHOPSESSION, onUpdateWorkshopSession)

  yield takeEvery(UPDATE_SUBDOMAIN, onUpdateSubdomain)




  yield takeEvery(ADD_COURSE, onAddCourse)

  yield takeEvery(UPDATE_NEWS, onUpdateNews)

  yield takeEvery(ADD_MEGA, onAddNewMega)

  yield takeEvery(ADD_NEWS, onAddNews)

  yield takeEvery(ADD_PROJECT, onAddProject)

  yield takeEvery(ADD_SLIDER, onAddSlider)

  yield takeEvery(ADD_POPUP, onAddPopup)

  yield takeEvery(GET_MEGA, fetchMega)

  yield takeEvery(GET_NEWS, fetchNews)

  yield takeEvery(GET_PROJECTSNEW, fetchProjects)

  yield takeEvery(GET_SLIDER, fetchSlider)

  yield takeEvery(GET_DYNAMICFORM, fetcDynamicFormMega)

  yield takeEvery(GET_EVENT, fetcEventMega)

  yield takeEvery(GET_TeacherMega, fetcTeacherMega)

  yield takeEvery(GET_CourseSchedulesMega, fetchCourseSchedulesMega)

  yield takeEvery(GET_WorkshopSessionMega, fetchWorkshopSessionMega)

  yield takeEvery(GET_WORKSHOP, fetchWorkshop)

  yield takeEvery(GET_POPUP, fetchPopup)

  yield takeEvery(GET_USERS, fetchUsers)
  yield takeEvery(GET_USER_PROFILE, fetchUserProfile)
  yield takeEvery(ADD_NEW_USER, onAddNewUser)

  yield takeEvery(ADD_USER, onAddUser)
  
  yield takeEvery(UPDATE_USER, onUpdateUser)
  yield takeEvery(DELETE_USER, onDeleteUser)
}

export default contactsSaga;
